import { ReactElement } from "react";
import Layout from "../../components/layout";
import NeighborhoodDetailsView from "../../components/Neighborhood/NeighborhoodDetailsView";

const NeighorhoodViewPage = (): ReactElement => {
  return (
    <Layout>
      <NeighborhoodDetailsView />
    </Layout>
  );
};

export default NeighorhoodViewPage;
